import { axiosInstance } from '../../utils'
import type { NavMenuItem } from './types'

export * from './types'

export function retrieveNavbar(): Promise<NavMenuItem[]> {
  return axiosInstance.get('/navbar.json', {
    baseURL: '/',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
    },
  })
}
